import { GameState } from "../state";
import { dist2, len } from "../../core/math";

// Advance projectiles and resolve enemy collisions with pierce support.
export function updateProjectiles(s: GameState, dt: number): void {
  for (const pr of s.projectiles) {
    if (!pr.alive) continue;
    pr.x += pr.vx * dt;
    pr.y += pr.vy * dt;
    pr.life -= dt;

    if (pr.life <= 0 || pr.x < -40 || pr.y < -40 || pr.x > s.arenaW + 40 || pr.y > s.arenaH + 40) {
      pr.alive = false;
      continue;
    }

    // Hostile (boss) projectiles damage PCKT instead of enemies.
    if (pr.hostile) {
      const p = s.player;
      if (p.invuln <= 0 && dist2(pr.x, pr.y, p.x, p.y) <= (pr.radius + p.radius) ** 2) {
        p.integrity -= pr.damage;
        p.invuln = 0.6;
        s.damageFlash = 1;
        s.addShake(5);
        s.ring(p.x, p.y, "#ff5454", 10, 180);
        if (p.integrity <= 0) {
          p.integrity = 0;
          s.phase = "gameover";
        }
        pr.alive = false;
      }
      continue;
    }

    for (const e of s.enemies) {
      if (!e.alive || pr.hitSet.has(e)) continue;
      const rr = (pr.radius + e.radius) ** 2;
      if (dist2(pr.x, pr.y, e.x, e.y) <= rr) {
        pr.hitSet.add(e);
        let kx = 0;
        let ky = 0;
        if (pr.knockback > 0) {
          const m = len(pr.vx, pr.vy) || 1;
          kx = (pr.vx / m) * pr.knockback;
          ky = (pr.vy / m) * pr.knockback;
        }
        s.damageEnemy(e, pr.damage, pr.crit, kx, ky);
        if (pr.pierce-- <= 0) {
          pr.alive = false;
          break;
        }
      }
    }
  }

  if (s.projectiles.length > 600) s.projectiles = s.projectiles.filter((p) => p.alive);
}
